import axios from "axios";
import { isEmpty } from "lodash";

import { getSession, clearSession, getCustomerSession } from "services/service";

const AxiosDefault = async ({ method, data, url, contentType, isCustomer }) => {
  const APIENDPOINT = process.env.REACT_APP_API_END_POINT;

  const AxiosInstance = axios.create({
    baseURL: APIENDPOINT,
    headers: {
      "Content-Type": isEmpty(contentType) ? "application/json" : contentType,
      Accept: "application/json",
    },
  });

  AxiosInstance.interceptors.request.use(
    async function (config) {
      try {
        const { Authorization } = getSession() ?? {};
        const { CustomerAuthorization } = getCustomerSession() ?? {};

        config.headers.Token = `${
          !isCustomer ? Authorization : CustomerAuthorization
        }`;
      } catch (err) {
        console.log("config error ======>", err);
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  AxiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      if (error?.response?.status === 401) {
        try {
          clearSession();

          const currentRoute = window.location.pathname;
          if (
            currentRoute !== "/parker-login" &&
            currentRoute !== "/customer-dashboard"
          ) {
            window.location.replace("/");
          } 
        } catch (err) {
          console.error("401 handling error:", err);
        }
      }

      return Promise.reject(error);
    }
  );

  return await AxiosInstance({
    method,
    data,
    url,
    contentType,
  });
};

export default AxiosDefault;
